import {
  MilestoneStatus,
  RaidCategory,
  RaidSeverity,
  RaidStatus,
} from "apps/project-iq/components/WorkspacePlan/WorkspacePlan.types";
import { DeliverableStatus } from "models/IProjectIQWorkspace";
import {
  dashboardTokens,
  IPortfolioPillTone,
} from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.tokens";
import { PortfolioLogTab } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.types";

export const MILESTONE_DELIVERABLE_STATUS_TONE: Record<
  MilestoneStatus | DeliverableStatus,
  IPortfolioPillTone
> = {
  not_started: dashboardTokens.status.milestone.upcoming,
  in_progress: dashboardTokens.status.milestone.active,
  done: dashboardTokens.status.milestone.done,
};

export const RAID_LIFECYCLE_STATUS_TONE: Record<
  RaidStatus,
  IPortfolioPillTone
> = {
  not_started: dashboardTokens.status.raidLifecycle.open,
  in_progress: dashboardTokens.status.raidLifecycle.mitigating,
  closed: dashboardTokens.status.raidLifecycle.closed,
};

export const RAID_SEVERITY_TONE: Record<RaidSeverity, IPortfolioPillTone> = {
  high: dashboardTokens.status.raidSeverity.high,
  medium: dashboardTokens.status.raidSeverity.med,
  low: dashboardTokens.status.raidSeverity.low,
};

export const RAID_CATEGORY_PILL_LABEL: Record<RaidCategory, string> = {
  risk: "Risk",
  action: "Action",
  issue: "Issue",
  decision: "Decision",
};

export interface IPortfolioLogTabConfig {
  tab: PortfolioLogTab;
  label: string;
}

export const PORTFOLIO_LOG_TABS: IPortfolioLogTabConfig[] = [
  { tab: "milestones", label: "Milestones" },
  { tab: "deliverables", label: "Deliverables" },
  { tab: "raid", label: "RAID Logs" },
];

export const DEFAULT_PORTFOLIO_LOG_TAB: PortfolioLogTab = "milestones";

const LOG_TAB_EMPTY_STATE_NOUN: Record<PortfolioLogTab, string> = {
  milestones: "milestones",
  deliverables: "deliverables",
  raid: "RAID entries",
};

export const getLogEmptyStateHeadline = (logTab: PortfolioLogTab): string =>
  `No ${LOG_TAB_EMPTY_STATE_NOUN[logTab]} logged yet`;

export const LOG_EMPTY_STATE_HINT =
  "Entries added in this workspace's Engagement Plan appear here.";

export const PORTFOLIO_GROUP_EMPTY_STATE_MESSAGE =
  "No portfolios are assigned to you yet.";

export const PORTFOLIO_ACCESS_DENIED_MESSAGE =
  "You don't have access to the Portfolios dashboard. Ask a Project IQ administrator for Portfolio Viewer access.";

export const PORTFOLIO_ACCESS_ERROR_MESSAGE =
  "We couldn't verify your access to the Portfolios dashboard. Please try again.";

export const PORTFOLIO_DATA_ERROR_MESSAGE =
  "We couldn't load the Portfolios dashboard data. Please try again.";

export const PRACTICE_GROUP_EMPTY_STATE_MESSAGE =
  "No practices are assigned to you yet.";

export const PRACTICE_ACCESS_DENIED_MESSAGE =
  "You don't have access to the Practices dashboard. Ask a Project IQ administrator for Practice Viewer access.";

export const PRACTICE_ACCESS_ERROR_MESSAGE =
  "We couldn't verify your access to the Practices dashboard. Please try again.";

export const PRACTICE_DATA_ERROR_MESSAGE =
  "We couldn't load the Practices dashboard data. Please try again.";
